import { parsePhoneNumber } from 'libphonenumber-js/max';
const required = phoneItem => {
  if (!phoneItem || !phoneItem.number) return false;
  return true;
};
const valid = (phoneItem, defaultCountry) => {
  if (!phoneItem || !phoneItem.number) return true;
  try {
    const prefix = phoneItem.prefix.startsWith('+') ? phoneItem.prefix : `+${phoneItem.prefix}`;
    const phone = parsePhoneNumber(`${prefix}${phoneItem.number}`, defaultCountry);
    if (!phone) return false;
    return phone.isValid();
  } catch (e) {
    return false;
  }
};
export const phone = {
  required,
  valid
};